"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Feeds = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var Feeds = /** @class */function (_super) {
  __extends(Feeds, _super);
  function Feeds() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.renderFeeds = function () {
      var feedView = [];
      var contentLength = _this.props.content.length;
      _this.props.content.map(function (eachContent, index) {
        var defaultClassName = "h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white";
        if (eachContent.iconClass) {
          defaultClassName += " ".concat(eachContent.iconClass);
        }
        feedView.push(react_1.default.createElement("li", {
          key: index
        }, react_1.default.createElement("div", {
          className: "relative pb-8"
        }, index + 1 < contentLength && react_1.default.createElement("span", {
          className: "absolute top-4 left-4 -ml-px h-full w-0.5 bg-gray-200",
          "aria-hidden": "true"
        }), react_1.default.createElement("div", {
          className: "relative flex space-x-3"
        }, react_1.default.createElement("div", null, react_1.default.createElement("span", {
          className: defaultClassName
        }, eachContent.iconType)), react_1.default.createElement("div", {
          className: "min-w-0 flex-1 pt-1.5 flex justify-between space-x-4"
        }, react_1.default.createElement("div", null, react_1.default.createElement("p", {
          className: "text-sm text-gray-500 ".concat(_this.props.bold ? "font-bold" : "")
        }, eachContent.content), eachContent.addContent && eachContent.addContent), react_1.default.createElement("div", {
          className: "text-right text-sm whitespace-nowrap text-gray-500"
        }, eachContent.step))))));
        return null;
      });
      return feedView;
    };
    return _this;
  }
  Feeds.prototype.render = function () {
    return react_1.default.createElement("ul", {
      className: "-mb-8"
    }, this.renderFeeds());
  };
  return Feeds;
}(react_1.Component);
exports.Feeds = Feeds;